<template>
  <div v-loading="loading" class="home-container" ref="container" @wheel="handlewheel">
    <ul class="carousel-container" :style="{ marginTop, }" @transitionend="handleTransitionEnd">
      <li v-for="item in data" :key="item.id">
        <CarouselItem :carousel="item" />
      </li>
    </ul>
    <div v-show="index >= 1" @click="switchTo(index - 1)" class="icon icon-up">
      <Icon type="arrowUp" />
    </div>
    <div v-show="index < data.length - 1" @click="switchTo(index + 1)" class="icon icon-down">
      <Icon type="arrowDown" />
    </div>
    <ul class="indicator">
      <li :class="{ active: i === index }" v-for="(item, i) in data" :key="item.id" @click="switchTo(i)"></li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CarouselItem from './CarouselItem.vue';
import Icon from '@/components/Icon.vue';

export default {

  components: {
    CarouselItem,
    Icon,
  },
  data() {
    return {
      // banners: [],
      index: 0,
      containerHeight: 0,
      switching: false,
      isLoading: true,
    }
  },
  // async created() {
  //   this.banners = await getBanners();
  //   this.isLoading=false;
  // },
  created() {
    this.$store.dispatch("banner/fetchBanner");
  },
  mounted() {
    this.containerHeight = this.$refs.container.clientHeight;
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    marginTop() {
      return -this.index * this.containerHeight + "px";
    },
    ...mapState("banner", ["loading", "data"])
  },
  methods: {
    switchTo(i) {
      this.index = i;
    },
    handlewheel(e) {
      if (this.switching || (e.deltaY <= 5 && e.deltaY >= -5)) {
        return
      }
      if (e.deltaY <= -5 && this.index > 0) {
        this.switching = true;
        this.index--;
      }
      else if (e.deltaY >= 5 && this.index < this.data.length - 1) {
        this.switching = true;
        this.index++;
      }
    },
    handleTransitionEnd() {
      this.switching = false;
    },
    handleResize() {
      this.containerHeight = this.$refs.container.clientHeight;
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../style/mixin.less";
@import "../../style/var.less";

.home-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  // width: 400px;
  // height: 300px;
  // overflow: visible;
  // border: 2px solid #008c8c;
  // margin: 100px auto;

  .carousel-container {
    width: 100%;
    height: 100%;
    transition: 500ms;

    li {
      width: 100%;
      height: 100%;
    }
  }

  ul {
    margin: 0;
    list-style: none;
    padding: 0;
  }

  .icon {
    .self-center();
    font-size: 30px;
    color: @gray;
    cursor: pointer;
    transform: translateX(-50%);
    @gap: 25px;

    &.icon-up {
      top: @gap;
      animation: jump-up 2s infinite;
    }

    &.icon-down {
      top: auto;
      bottom: @gap;
      animation: jump-down 2s infinite;
    }

    @jump: 10px;

    @keyframes jump-up {
      0% {
        transform: translate(-50%, @jump);
      }

      50% {
        transform: translate(-50%, -@jump);
      }

      100% {
        transform: translate(-50%, @jump);
      }
    }

    @keyframes jump-down {
      0% {
        transform: translate(-50%, -@jump);
      }

      50% {
        transform: translate(-50%, @jump);
      }

      100% {
        transform: translate(-50%, -@jump);
      }
    }
  }

  .indicator {
    .self-center();
    transform: translateY(-50%);
    left: auto;
    right: 20px;

    li {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: @words;
      cursor: pointer;
      margin-bottom: 10px;
      border: 2px solid #fff;
      box-sizing: border-box;

      &.active {
        background: #fff;
      }
    }
  }
}
</style>